import { ListBox } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';
import Currency from '../../../shared_components/Currency/Currency';
import ShoppingBasketStatusPill from './ShoppingBasketStatusPill';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import SpinOffMessage from '../../CheckoutPage/components/SpinOffMessage';
import { isLoggedOnSelector } from '../../../recoil/selectors/isLoggedOnSelector';
import { useRecoilValue } from 'recoil';
import { shouldHideName } from '../utils/ShoppingBasketUtil';
import { isAccCoverableForOtherPerson } from '../../../utils/coverablesUtil';

const ShoppingBasketCoverable = ({
    coverable,
    price,
    paymentFrequencyPostfix,
    shouldDisplayCoverableAsCancelled = false,
    children
}: {
    coverable: CoverableDTO;
    price: number;
    paymentFrequencyPostfix: string;
    shouldDisplayCoverableAsCancelled?: boolean;
    children?: React.JSX.Element;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const hippoText = {
        removedCoverableIcon: getHippoText('DSS-SHOPPING-BASKET-REMOVED-COVERABLE-ICON')
    };
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    return (
        <div className="coverable-item">
            <ListBox
                variant="eCommerce"
                theme={shouldDisplayCoverableAsCancelled ? 'disabled' : undefined}
                title={
                    <span
                        className={
                            'u-flex-box u-flex-box--center u-flex-box--space-between u-flex-box--no-gap u-flex-box--nowrap'
                        }
                    >
                        <span className="u-flex-box u-flex-box--center u-flex-box--gap-xsmall u-flex-box--nowrap">
                            <span>{coverable.flavourName}</span>
                            <ShoppingBasketStatusPill coverableStatus={coverable.status} />
                        </span>
                        <span className="u-text-right" style={{ marginLeft: 'auto' }}>
                            {shouldDisplayCoverableAsCancelled ? (
                                hippoText.removedCoverableIcon
                            ) : (
                                <Currency
                                    price={price}
                                    paymentFrequencyPostfix={paymentFrequencyPostfix}
                                />
                            )}
                        </span>
                    </span>
                }
                addonContent={
                    <>
                        <div className="u-flex-box u-flex-box--center u-flex-box--space-between">
                            <p className="u-spacing-stack-none">
                                {shouldHideName(coverable, isLoggedOn) ? '' : coverable.name}
                            </p>
                        </div>
                        {isAccCoverableForOtherPerson(coverable) && (
                            <SpinOffMessage
                                coverable={coverable}
                                message={getHippoText('DSS-SHOPPING-BASKET-OFFER-FOR-OTHER-LABEL', {
                                    Coverable_name: coverable.name ?? ''
                                })}
                                showAccidentModal={true}
                            />
                        )}
                    </>
                }
            >
                {children}
            </ListBox>
            <div className="u-spacing-stack-m" />
        </div>
    );
};

export default ShoppingBasketCoverable;
